/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
// import { Link as RouterLink } from 'react-router-dom';
import { List, Box, ListSubheader } from '@mui/material';

import { LoadingButton } from '@mui/lab';
import { useState, useEffect } from 'react';
import Popup from 'reactjs-popup';

import 'reactjs-popup/dist/index.css';
import '../../../sections/auth/register/popup.css';

import { NavListRoot } from './NavList';

// import Login2 from '../../../pages/auth/Login2';

import { PopupLogin } from '../../../sections/auth/PopupLogin';
// import { useEffect } from 'react';

// import Navbuton from '../components/Navbuton';
// import Navbuton from "../../Navbuton";

// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled((props) => <ListSubheader disableSticky disableGutters {...props} />)(
  ({ theme }) => ({
    ...theme.typography.overline,
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter,
    }),
  })
);

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
  navConfig: PropTypes.array,
};

const EmailValue = window.localStorage.getItem('email_popup');

export default function NavSectionVertical({ navConfig, isCollapse = false, ...other }) {
  const [open, setOpen] = useState(false);
  const [newopen, setNewOpen] = useState(false);
  const [author, setAuthor] = useState(0);
  const [usertype, setUserType] = useState(window.localStorage.getItem('user_type'));

  const closeModal = () => setOpen(false);
  const closeModal1 = () => setNewOpen(false);
  useEffect(() => {}, [usertype]);

  const setNewUserType = (newType) => {
    setUserType(`${usertype},${newType}`);
  };

  return (
    <>
      <div>
        {usertype === '3' ? (
          <LoadingButton
            fullWidth
            size="large"
            variant="contained"
            style={{
              borderRadius: 35,

              padding: '18px 36px',
              fontSize: '18px',
              boxShadow: 'none',
              width: '150px',
              textAlign: 'center',
              marginLeft: '55px',
            }}
            type="button"
            className="button"
            onClick={() => {
              setOpen((o) => !o);
              setAuthor('2');
            }}
          >
            Author
          </LoadingButton>
        ) : usertype === '3,2' || usertype === '2,3' ? (
          <> </>
        ) : (
          <LoadingButton
            fullWidth
            size="large"
            variant="contained"
            style={{
              borderRadius: 35,

              padding: '18px 36px',
              fontSize: '18px',
              boxShadow: 'none',
              width: '150px',
              textAlign: 'center',
              marginLeft: '55px',
            }}
            type="button"
            className="button"
            onClick={() => {
              setAuthor('3');
              setOpen((o) => !o);
            }}
          >
            Coach
          </LoadingButton>
        )}

        <Popup className="double-popup" open={open} author={author} closeOnDocumentClick onClose={closeModal}>
          <div className="modal-popup">
            <a className="close" onClick={closeModal}>
              x
            </a>
            <span>
              {usertype === '3'
                ? 'This user is already registered as an coach. Would you like to register it as a author as well'
                : 'This user is already registered as an author. Would you like to register it as a coach as well'}
            </span>
            <br />
            <button
              className="button btn btn-yes"
              type="button"
              onClick={() => {
                setOpen(false);
                // setAuthor('2');
                setNewOpen((o) => !o);
              }}
            >
              Yes
            </button>

            <button className="button btn btn-no" onClick={closeModal}>
              No
            </button>
          </div>
        </Popup>

        <PopupLogin open={newopen} radio={author} setType={setNewUserType} closeOnDocumentClick onClose={closeModal1} />
      </div>

      <Box {...other}>
        {navConfig?.map((group) => (
          <List key={group.subheader} disablePadding sx={{ px: 2 }}>
            <ListSubheaderStyle
              sx={{
                ...(isCollapse && {
                  opacity: 0,
                }),
              }}
            >
              {group.subheader}
            </ListSubheaderStyle>

            {group?.items?.map((list) => (
              <NavListRoot key={list.title} list={list} isCollapse={isCollapse} />
            ))}
          </List>
        ))}
      </Box>
    </>
  );
}
